import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { TReduxAction } from '../interfaces/TReduxState';

export const useMainDispatch = () => useDispatch<Dispatch<TReduxAction>>();
